/**
 * @return {void}
 */
module.exports = function openRoiCalculatorDialog() {
    document.querySelectorAll('[data-component="roi-calculator-dialog-trigger"]').forEach(trigger => {
        if (trigger instanceof HTMLButtonElement) {
            trigger.click();
        }
    });
}
